import { render, staticRenderFns } from "./SingPauseMitgliederKlassen.vue?vue&type=template&id=606c765d&"
import script from "./SingPauseMitgliederKlassen.vue?vue&type=script&lang=js&"
export * from "./SingPauseMitgliederKlassen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports